import { Component,Input, OnInit,OnDestroy } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HelperService } from '../../core/services/helper.service';
import { ShoppingService } from '../../core/services/shopping.service';
import { UserModel } from '../../core/models/ShoppingCart.model';
import { appVariables,appMessages, Application, appRoles ,accessLevel} from '../../core/constants/Common.constant';
import { environment } from '../../../environments/environment';
import { Title } from '@angular/platform-browser';
import { overLimitCartDetails } from '../../../app/core/constants/Common.constant';
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-order-complete',
  templateUrl: './order-complete.component.html',
  styleUrls: ['./order-complete.component.css'],
})
export class OrderCompleteComponent implements OnInit ,OnDestroy {
  result:any;
  buttonText:boolean;
  Products = [];
  roleType: string;
  ShippedProduct = [];
  DigitalProduct = [];
  ConfirmOrderObj: any;
  TotalShippedQuantity = 0;
  isLTI:string;
  isLTIOrderComplete: string;
  IsAnyProductIsPrintProduct:boolean=false;
  packageProductNote:string;
  cartQuantityLimit = overLimitCartDetails;
  FirstProductindex:any;
  noAccess:string;
  constructor(private helperService: HelperService, private shoppingService: ShoppingService, private titleService: Title) {
    this.titleService.setTitle('Order Confirmation | F.A. Davis');
  }

  ngOnInit() {
    this.shoppingService.IsLoggedIn.emit(true);
    this.shoppingService.GetApplicationDetails();
    this.TotalShippedQuantity = 0;
    this.ConfirmOrderObj = JSON.parse(this.helperService.getFromLocalStorage(appVariables.successOrderResponse));
    this.isLTI =  this.helperService.getFromLocalStorage(appVariables.isLTI);
    this.isLTIOrderComplete = appMessages.isLTIOrderComplete;
    this.packageProductNote = appMessages.PackageProductNote;
    this.roleType = this.helperService.getFromLocalStorage('role');
    this.noAccess = appVariables.NoAccess;//LMM-6116
    
    if (this.ConfirmOrderObj['Data'].orderCalculation.orderCalculationDetailsField) {
      this.FirstProductindex = null;  
      this.ConfirmOrderObj['Data'].orderCalculation.orderCalculationDetailsField.sort((a, b) => b.ProductTypeID - a.ProductTypeID);
      let productListwithoutPkg = this.ConfirmOrderObj['Data'].orderCalculation.orderCalculationDetailsField.filter(x => x.ProductTypeID != 6);  
      if(productListwithoutPkg != null){

    const responseArray = this.ConfirmOrderObj.Data.orderCalculation.orderCalculationDetailsField;
    const displayISBNArray = responseArray.map(item => item.DisplayISBN);
    const displayISBNString = displayISBNArray.join(',');
    let displayISBNStr = '';
    for (const item of responseArray) {
      let childs = []; 
      if (item.ChildProducts) {
          childs = item.ChildProducts.map(child => child.DisplayISBN);
          if (childs.length > 0) {
              if (displayISBNStr !== '') {
                  displayISBNStr += ','; 
              }
              displayISBNStr += childs.join(','); 
          }
      }   
  }
     
  this.shoppingService.GetMyProductList(undefined,undefined,undefined,undefined,displayISBNStr).subscribe(
    (response) => {
       this.Products= response.Products.ProductList;
       for (const item of this.Products) {
        if (item.AccessList && Array.isArray(item.AccessList)) {
          for (const accessTypeItem of item.AccessList) {
            this.result= accessTypeItem.AccessType;
            item.buttonText = (item.AccessLevelID === accessLevel.tempAccess && (this.result === null) && this.roleType !== appRoles.Instructor) ? true : false;
                this.ConfirmOrderObj['Data'].orderCalculation.orderCalculationDetailsField.map((obj2)=>{
                  if(obj2.DisplayISBN==item.PackageISBN){
                    for(const childs of obj2.ChildProducts){
                    if(childs.DisplayISBN === item.ISBN){
                      childs.showButton = item.buttonText;
                    }
                    }
                  }
                })
                break;
            
          }
        }
      }
      },
    (error) => {
      console.error(error);
    }
  ); 



      this.FirstProductindex = this.ConfirmOrderObj['Data'].orderCalculation.orderCalculationDetailsField.findIndex(x => x.ProductID = productListwithoutPkg[0].ProductID && x.ProductTypeID != 6);
      }
      this.ShippedProduct = this.ConfirmOrderObj['Data'].orderCalculation.orderCalculationDetailsField.filter(obj =>
        //  FAD173
        (obj.appid === 2 || obj.appid === 5) && obj.ProductTypeID !== 3);
      for (let i = 0; i < this.ShippedProduct.length; i++) {
        this.TotalShippedQuantity += Number(this.ShippedProduct[i].quantityField);
      }

    }
    if (this.ConfirmOrderObj['Data'].orderCalculation.orderCalculationDetailsField) {
      this.DigitalProduct = this.ConfirmOrderObj['Data'].orderCalculation.orderCalculationDetailsField.filter(obj =>
        obj.ProductTypeID === 3);
    }
    const token = this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage);
    this.helperService.setToLocalStorage(appVariables.accessTokenLocalStorage, token);
    this.helperService.setToLocalStorage(appVariables.displaySection, '');
    this.helperService.setToLocalStorage(appVariables.promoCode, '');
    this.helperService.setToLocalStorage(appVariables.addressMode, '');
    // this.helperService.setToLocalStorage(appVariables.successOrderResponse, '');

    this.shoppingService.IsOrderCompleteComponent.emit(true);
    this.shoppingService.IsCheckoutComponent.emit(false);
      window.onbeforeunload = () => {
        localStorage.removeItem('isLTI');
      }
    this.IsAnyProductIsPrintProduct=this.ConfirmOrderObj.Data.orderCalculation.orderCalculationDetailsField.findIndex(e => e.ProductTypeID ==1)>-1;
    const responseArray = this.ConfirmOrderObj.Data.orderCalculation.orderCalculationDetailsField;
    const displayISBNArray = responseArray.map(item => item.DisplayISBN);
    const displayISBNString = displayISBNArray.join(',');
     
   this.shoppingService.GetMyProductList(undefined,undefined,undefined,undefined,displayISBNString).subscribe(
      (response) => {
         this.Products= response.Products.ProductList;
         for (const item of this.Products) {
          if (item.AccessList && Array.isArray(item.AccessList)) {
            for (const accessTypeItem of item.AccessList) {
              this.result= accessTypeItem.AccessType;
              if(item.AccessLevelID==accessLevel.tempAccess && this.result==null && (this.roleType!== appRoles.Instructor)){
                this.Products.map((obj)=>{
                  item.buttonText=true;

                  this.ConfirmOrderObj['Data'].orderCalculation.orderCalculationDetailsField.map((obj2)=>{
                    if(obj2.DisplayISBN === item.ISBN){
                      obj2.showButton = item.buttonText;
                    }
                  })
                })
              }
            }
          }
        }
        },
      (error) => {
        console.error(error);
      }
    );  
  }



  ngOnDestroy(){
    localStorage.removeItem('isLTI');
  }

  OnAccessNowClick(Url: string, appid) {
    // +'?token='+this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage)
    if (appid === 11 || appid === '11') {
      if (Url.slice(-1) === '/') {
        Url = Url.slice(0, -1);
      }
      window.open(Url + '/accounts/authenticate/?token=' + this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage), '_blank');
    } else {
      window.open(Url, '_blank');
    }
  }
  setDefaultPic(cartitems) {
    cartitems.productImageUrl = environment.defaultProductImage; // 'assets/images/my-image.png';
  }
  setParentPic(cartitems) {
    // let isbn = '';
    this.shoppingService.GetParentProductImageFromAPI('1', cartitems.iSBNField)
      .subscribe(
        (response) => {
          cartitems.productImageUrl = response.Data;
        },
        (error) => {
          // .status === 401
          if (error) {

          }
        }
      );
  }

  RedirectToProduct(URL, AppId) {
    if(AppId==Application.DavisAdvantage.AppId) {
      let token = (this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage)) ? this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage) : ``;
      URL = (URL==null || URL=='') ? environment.SSOProducts : `${environment.davisadvantageLoginUrl}?token=${token}`;
    }
      window.open((URL==null || URL=='') ? environment.SSOProducts : URL, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/order-complete/order-complete.component.ts